import { Component, Input } from '@angular/core';
import { SettlementsService } from 'src/app/services/settlements.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { IconsService } from 'src/app/shared/services/icons.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: '[app-tr-perfil]',
  template: `
    <td class="align-middle text-start"><img [src]="avatarURL" width="100%"> {{perfil.name}}</td>
    <td class="align-middle text-start">{{perfil.rfc}}</td>
    <td class="align-middle text-center">{{perfil.thsm_company_id}}</td>
    <td class="align-middle text-end">
      <button class="btn btn-link" routerLink="edit/{{perfil.id}}" *ngIf="authService.hasPermission('can_edit_companies')">
        <fa-icon [icon]="icons.faEdit"></fa-icon>
      </button>
      <button class="btn btn-link" routerLink="dashboard/{{profile.id}}" *ngIf="authService.hasPermission('can_edit_companies')">
        <fa-icon [icon]="icons.faGauge"></fa-icon>
      </button>
    </td>
  `,
  styles: ``
})
export class TrPerfilComponent {
  @Input() perfil: any;
  @Input() profile: any;

  apiUrl: string = environment.AWS_REST_WSPREFIX;
  avatarURL: string = '';

  constructor(
    private store: SettlementsService,
    public icons: IconsService,
    public authService: AuthService
  ) { }
}
